import { inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

import { AppModule } from './app/app.module';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/interceptors/auth.interceptor';

const DEFAULT_LANG = 'es';
const FALLBACK_LANG = 'en';

platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [
      provideZoneChangeDetection(),
      provideHttpClient(withInterceptors([authInterceptor])),
      provideTranslateService({
        loader: provideTranslateHttpLoader({
          prefix: '/public/i18n/',
          suffix: '.json',
        }),
        fallbackLang: FALLBACK_LANG,
        lang: DEFAULT_LANG,
      }),
      // Bloquea el arranque de la app hasta que el idioma esté completamente
      // cargado. Así ningún componente (ni las llamadas a translate.instant())
      // se ejecuta antes de tener las traducciones, evitando que aparezcan las
      // claves crudas (p. ej. "home.title") tras recargar la página.
      provideAppInitializer(() => {
        const translate = inject(TranslateService);
        translate.addLangs([FALLBACK_LANG, DEFAULT_LANG]);
        return firstValueFrom(translate.use(DEFAULT_LANG));
      }),
    ],
  })
  .catch((err) => console.log(err));
